export default __webpack_public_path__ + "static/img/share.26b86bb.jpg";